<template>
  <div>
    <v-dialog persistent :value="editModal" width="500" @keydown.esc="closeModal()">
      <v-card>
        <v-card-title>{{ 'Edit ' + form.name }}</v-card-title>
        <v-card-text>
          <div>
            <v-form ref="updateForm" lazy-validation>
              <v-text-field
                v-model="form.name"
                :rules="textValidation"
                name="Name"
                label="Name"
                required
                validate-on-blur
                type="text"
              ></v-text-field>
              <v-select
                v-model="form.parent_category"
                :items="listItem"
                item-text="name"
                item-value="id"
                label="Parent Category"
                dense
              ></v-select>
              <v-select
                v-model="form.thc_cbd_value_type"
                :items="choices.thcCbdValueType"
                label="THC/CBD Type"
                dense
              ></v-select>
              <v-select
                v-model="form.product_form"
                :items="choices.productForm"
                label="Product Form"
                dense
              >
              </v-select>
              <v-text-field
                v-model="form.description"
                name="Description"
                label="Description"
                required
                validate-on-blur
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="form.sort_order"
                :rules="positiveNumberValidation"
                name="Order"
                label="Order"
                required
                validate-on-blur
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                type="number"
              ></v-text-field>
              <v-text-field
                v-model="form.inventory_threshold"
                name="Inventory Threshold"
                label="Inventory Threshold"
                required
                validate-on-blur
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                type="number"
              ></v-text-field>
              <v-text-field
                v-model="form.external_id"
                name="External Id"
                label="External Id"
              ></v-text-field>
              <v-flex sm12 md12 class="text-left">
                <img
                  class="display-img"
                  :src="form.image"
                  alt
                  v-if="form.image"
                />
              </v-flex>
              <v-switch
                :prepend-icon="'fas fa-heart'"
                v-model="form.featured"
                name="Featured"
                label="Featured"
                color="primary"
              ></v-switch>
              <div class="text-left mb-3">
                <v-btn
                  class="ml-0"
                  color="primary"
                  @click.prevent="openAttachmentPopup()"
                >
                  <v-icon dark left>fas fa-image</v-icon>
                  {{ form.image == '' ? 'select image' : 'update image' }}
                </v-btn>
              </div>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="closeModal()"
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
            style="text-transform: capitalize;"
            >Cancel</v-btn
          >
          <v-btn
            @click="updateData()"
            color="white"
            :class="
              $vuetify.breakpoint.width > 960
                ? 'ml-0 mr-0 primary'
                : 'ml-0 primary'
            "
            style="text-transform: capitalize;"
            >Edit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { LocationCategoryAPI } from '@/clients/location/location.category.api'
import Helper from '@/utility/Helpers'
import _ from 'lodash'

export default {
  data() {
    return {
      normalValidation: [v => !!v || 'Field is required'],
      textValidation: [
        v => !!v || 'Field is required',
        v => Helper.validateSpace(v) || `Blank value.`
      ],
      positiveNumberValidation: [
        v => !!v || 'Field is required',
        v => /^\+?([0-9]\d*)$/.test(v) || 'Positive Numbers only'
      ],
      NumberValidation: [
        v => /^\+?([0-9]\d*)$/.test(v) || 'Positive Numbers only'
      ],
      form: {
        name: '',
        parent_category: '',
        description: '',
        sort_order: null,
        location_id: '',
        inventory_threshold: '',
        image: '',
        featured: false,
        thc_cbd_value_type: '',
        external_id: null,
        product_form: ''
      },
      listItem: [],
      choices: {
        thcCbdValueType: [
          { text: 'Range', value: 'range' },
          { text: 'Single', value: 'single' }
        ],
        productForm: [
          { text: 'None', value: null },
          { text: 'Dried Flower', value: 'dried flower' },
          { text: 'Pre Rolled', value: 'pre rolled' },
          { text: 'Oil', value: 'oil' },
          { text: 'Capsules', value: 'capsules' },
          { text: 'Spray', value: 'spray' },
          { text: 'Edible', value: 'edible' },
          { text: 'Beverages', value: 'beverages' },
          { text: 'Vapes', value: 'Vapes' },
          { text: 'Topical', value: 'topical' },
          { text: 'Other', value: 'other' },
          { text: 'Accessories', value: 'accessories' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      editModal: 'locationcategory/editPop',
      editObj: 'locationcategory/editObj',
      selectedLocation: 'location/selected'
    })
  },
  watch: {
    editObj: async function(val) {
      if (!_.isEmpty(val)) {
        await this.locationCategoryList(val)
        for (let key in this.form) {
          this.form[key] = val[key]
        }
      } else {
        Helper.setObjValueEmpty(this.form)
      }
    }
  },
  mounted() {
    if (this.editModal) {
      this.closeModal()
    }
    this.spinner(false)

    /**
     * Set image
     */
    this.$root.$on('resource-selected', event => {
      if (this.editModal) {
        this.form.image = event[0].full_url
      }
    })
  },
  methods: {
    async locationCategoryList(obj) {
      try {
        const { data } = await LocationCategoryAPI.fetch(
          this.selectedLocation.id
        )
        // remove current one
        _.remove(data.payload, ['name', obj.name])

        data.payload.forEach(each => {
          if (each.parent_category === null) {
            this.listItem.push(each)
          }
        })
        this.listItem = [
          { id: '', name: '', description: '' },
          ...this.listItem
        ]
      } catch (err) {
        this.listItem = []
      }
    },
    /**
     * Update
     */
    async updateData() {
      if (this.$refs['updateForm'].validate()) {
        try {
          this.form.location_id = this.selectedLocation.id
          // Trigger apis
          this.spinner(true)
          let result = await LocationCategoryAPI.edit(
            this.editObj.id,
            this.form
          )
          this.spinner(false)
          if (result.status === 200) {
            this.closeModal()
          }
          // Display message alert
          this.snackbar({
            text:
              result.status === 200
                ? result.data.msg
                : result.response.data.errors
                ? result.response.data.errors[0]
                : result.response.data.msg,
            open: true,
            color: result.status === 200 ? 'success' : 'error'
          })
          await this.va_locationCategoryList(this.selectedLocation.id)
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors
              ? err.response.data.errors[0]
              : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     * Popup for attachment
     */
    openAttachmentPopup() {
      this.openResourcePicker()
    },

    /**
     * Close modal
     */
    closeModal() {
      this.$refs.updateForm.reset()
      this.setEditPop(false)
      this.setEditObj({})
    },

    ...mapActions({
      va_locationCategoryList: 'locationcategory/setList',
      setEditPop: 'locationcategory/setEditPop',
      setEditObj: 'locationcategory/setEditObj'
    })
  }
}
</script>
